import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TabPanel from '../CalendarTabbar/TabPanel';
import Label from '../shared/Label';
import { CupTabbarWrapper, PhasesWrapper, SubPhasesWrapper, NodeTitleClone } from './styles';
import { isBasketCup, subPhaseLabel as subPhaseLabelCore } from '../../common/rcs_gaz_mc_core_FE';
import { isRoundInterval } from '../../helpers';

class CupCalendarTabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refLiFirst: false,
      refLiLast: false,
      hasScroll: false,
      subRefLiFirst: false,
      subRefLiLast: false,
      subRefHasScroll: false,
    };
    this.ref = React.createRef();
    this.subRef = React.createRef();
    this.commonStyle = {
      zIndex: 1, position: 'absolute', top: 0, width: '50px',
    };
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.currentPhase !== nextProps.currentPhase) || (this.props.currentSubPhase !== nextProps.currentSubPhase)) {
      this.setState({ HasScroll: false, subRefHasScroll: false });
      this.handleScroll('ref');
      this.handleScroll('subRef');
    }
  }

  componentDidUpdate() {
    this.handleScroll('ref');
    this.handleScroll('subRef');
  }

  setActiveTab = (tab) => {
    let subPhases = [];
    [...subPhases] = this.props.phases.getIn([tab, 'subPhases']);
    if (subPhases && subPhases.length > 0) {
      window.location.replace(`${window.location.origin}${window.location.pathname}?fase=${tab}&subfase=${subPhases[0][0]}`);
    } else {
      window.location.replace(`${window.location.origin}${window.location.pathname}?fase=${tab}`);
    }
    // this.props.actions.getCupCalendar(
    //   window.matchcenterPage.sportId,
    //   window.matchcenterPage.competitionId,
    //   tab,
    //   subPhases[0][0],
    //   window.matchcenterPage.seasonId,
    // );
  };

  setActiveSubTab = (subTab) => {
    window.location.replace(`${window.location.origin}${window.location.pathname}?fase=${this.props.currentPhase}&subfase=${subTab}`);
    // this.props.actions.getCupCalendar(
    //   window.matchcenterPage.sportId,
    //   window.matchcenterPage.competitionId,
    //   this.props.currentPhase,
    //   subTab,
    //   window.matchcenterPage.seasonId,
    // );
  };

  generateSubPhases = (tabs, current) => {
    let subPhases = [];
    const { sportId, competitionId } = window.matchcenterPage;
    const { isSpecial } = this.props;
    if (tabs) {
      if (isSpecial) {
        subPhases = tabs.getIn(['playoffs', 'subPhases']).toJS();
        subPhases = Object.keys(subPhases);
      } else {
        subPhases = tabs.getIn([current, 'subPhases']).keys();
        [...subPhases] = subPhases;
        if (subPhases[0] && isRoundInterval(subPhases[0])) {
          subPhases = subPhases.map((sPh) => {
            const value = `${sPh.substring(0, 4)}-${sPh.substring(4, 6)}-01`;
            const date = new Date(value).toLocaleDateString('it-IT', { year: 'numeric', month: 'short' });
            return { url: sPh, label: date };
          });
        }
      }
    }
    if (String(sportId) === '5' && (String(competitionId) === '2' || String(competitionId) === '3')) {
      return subPhases.filter(x => x.indexOf('5th') < 0);
    }
    return subPhases;
  };

  generatePhases = (tabs) => {
    let phases = [];
    if (tabs) {
      [...phases] = tabs.keys();
      const isNBA = String(window.matchcenterPage.sportId) === '3' && String(window.matchcenterPage.competitionId) === '3';
      phases = phases.filter((ph) => {
        if (ph !== 'regularSeason' && tabs.getIn([ph, 'subPhases']) && !isNBA) {
          let subPhases = tabs.getIn([ph, 'subPhases']).keys();
          [...subPhases] = subPhases;
          return subPhases.length > 0;
        }
        return true;
      });
    }
    //NASCONDO TEMPORANEAMENTE IL TAB PLAYOFF PER I MONDIALI (6) dI BASKET (3)
    // const { sportId, competitionId } = window.matchcenterPage;
    // if (String(sportId) === '3' && String(competitionId) === '6') {
    //   return phases.filter(x => x.indexOf('playoffs') < 0);
    // }
    const extraPlayoffsInd = phases.indexOf('extraPlayoffs');
    const playoffsInd = phases.indexOf('playoffs');
    if (extraPlayoffsInd > -1 && playoffsInd > -1) {
      phases[playoffsInd] = 'extraPlayoffs';
      phases[extraPlayoffsInd] = 'playoffs';
    }
    return phases;
  };

  subPhaseLabel = () => {
    let label = 'Giornate:';
    if (window.matchcenterPage.sportId === '5' && (window.matchcenterPage.competitionId === 34 || window.matchcenterPage.competitionId === 35)) {
      label = 'Round:';
    }
    return label;
  }

  subTabsLabel = (index, isUefaCompetition) => {
    index = isUefaCompetition && index.indexOf('qualifier-round') > -1 ? `${index}-el` : index;
    const newIndex = index.label || index;
    const { dictionary, isSpecial } = this.props;
    const { sportId, competitionId } = window.matchcenterPage;
    const subPhases = isSpecial ? dictionary.calendar.special.subPhases : dictionary.calendar.subPhases;
    return subPhaseLabelCore(newIndex, subPhases, sportId, competitionId, true);
  }

  phaseLabel = (index) => {
    const { dictionary, isSpecial } = this.props;
    const { sportId, competitionId } = window.matchcenterPage;
    const dictionaryPhase = isSpecial ? dictionary.calendar.special.phases : dictionary.calendar.phases;
    return subPhaseLabelCore(index, dictionaryPhase, sportId, competitionId, true);
  }

  scroll_button = (ref_txt, dir) => {
    const ref = this[ref_txt];
    const ul_rect = ref.getBoundingClientRect();
    const scroll = Math.floor(ul_rect.width / 2);
    let scrollAmount = 0;
    const step = 8;
    const slideTimer = setInterval(() => {
      if (dir === 'next') {
        ref.scrollLeft += step;
      } else {
        ref.scrollLeft -= step;
      }
      scrollAmount += step;
      if (scrollAmount >= scroll) {
        window.clearInterval(slideTimer);
      }
    }, 20);
  }

  scrollCenterMenu = (ref_txt) => {
    const hasScroll = `${ref_txt}HasScroll`;
    if (this.state[hasScroll]) {
      return;
    }
    const ref = this[ref_txt];
    if (!ref.children) {
      return;
    }
    const li_active = Array.from(ref.children).findIndex(obj => obj.classList.contains('tab-active'));
    if (!ref.children[li_active]) {
      return;
    }
    const li_active_rect = ref.children[li_active].getBoundingClientRect();
    let pos = li_active_rect.left + Math.round(li_active_rect.width / 2);
    const ulWidth = ref.getBoundingClientRect().width;
    pos = (pos + ref.scrollLeft) - Math.round(ulWidth / 2);
    ref.scrollLeft = pos;
    this.setState({ [hasScroll]: true });
  };

  handleScroll = (ref_txt) => {
    const ref = this[ref_txt];
    if (!ref.children) {
      return;
    }
    const len = ref.children.length;
    const liFirst = `${ref_txt}LiFirst`;
    const liLast = `${ref_txt}LiLast`;
    const hasScroll = `${ref_txt}HasScroll`;
    if (len > 0) {
      const ul_rect = ref.getBoundingClientRect();
      const li_last_rect = ref.children[len - 1].getBoundingClientRect();
      // uscita nel caso di menu corto
      if (Math.floor(ul_rect.right) > Math.floor(li_last_rect.right) && !this.state[hasScroll]) {
        return;
      }
      this.scrollCenterMenu(ref_txt);
      const li_first_rect = ref.children[0].getBoundingClientRect();
      if (((ul_rect.left - 10) > li_first_rect.left) && this.state[liFirst] === false) { this.setState({ [liFirst]: true }); }
      if (((ul_rect.left - 10) <= li_first_rect.left) && this.state[liFirst] === true) { this.setState({ [liFirst]: false }); }

      if (((ul_rect.right + 10) <= li_last_rect.right) && this.state[liLast] === false) { this.setState({ [liLast]: true }); }
      if (((ul_rect.right + 10) > li_last_rect.right) && this.state[liLast] === true) { this.setState({ [liLast]: false }); }
    }
  }

  spanPrevStyle = (liState) => {
    const style = Object.assign({
      left: '-5px',
      paddingLeft: '5px',
      textAlign: 'left',
      background: 'linear-gradient(270deg, rgba(253,233,235,0) 20%,#fde9eb 50%)',
    }, this.commonStyle);
    if (!liState) {
      style.display = 'none';
    }
    return style;
  }

  spanNextStyle = (liState) => {
    const style = Object.assign({
      right: '-5px',
      paddingRight: '5px',
      textAlign: 'right',
      background: 'linear-gradient(90deg, rgba(253,233,235,0) 0%,#fde9eb 70%)',
    }, this.commonStyle);
    if (!liState) {
      style.display = 'none';
    }
    return style;
  }

  isSpecialChampionship = () => {
    const {
      isVolleyChampionship, isRugby, isBasketSerieA, isFootballSerieB,
    } = this.props;
    return isVolleyChampionship || isRugby || isBasketSerieA || isFootballSerieB;
  }

  showTabs = (tabs) => {
    const { competitionId } = window.matchcenterPage;
    if (
      String(competitionId) === '335' ||
      (String(competitionId) === '105' && tabs.length < 2)
    ) {
      return false;
    }
    return true;
  }

  renderNestTitle = () => {
    const nodeTitle = document.querySelector('.title-matchcenter');
    nodeTitle.style.display = 'none';
    const newClone = nodeTitle.cloneNode(true);
    newClone.style.display = 'block';
    const nodeTitleOuterHTML = newClone.outerHTML;
    return (
      <NodeTitleClone dangerouslySetInnerHTML={{ __html: nodeTitleOuterHTML }} />
    );
  }

  render() {
    const {
      phases,
      currentPhase,
      currentSubPhase,
      isCup,
      isMobile,
      isVolleyChampionship,
      isInnerMenu, isRugby, isBasketSerieA, isFootballSerieB, isUefaCompetition,
    } = this.props;
    const tabs = this.generatePhases(phases);
    const subTabs = this.generateSubPhases(phases, currentPhase);
    const isRegular = (isVolleyChampionship && currentPhase === 'regular-season') || ((isRugby || isBasketSerieA) && currentPhase === 'regularSeason') || (isFootballSerieB && currentPhase === 'regularSeason');
    return (
      <CupTabbarWrapper className="CupTabbarWrapper" isMobile={isMobile} isInnerMenu={isInnerMenu} isVolleyChampionship={isVolleyChampionship} isSpecialChampionship={this.isSpecialChampionship()} isRegular={isRegular}>
        {tabs && tabs.length > 0 && this.showTabs(tabs) &&
          <React.Fragment>
            {this.isSpecialChampionship() && isInnerMenu ?
              null
              :
              <PhasesWrapper isMobile={isMobile} isSpecialChampionship={this.isSpecialChampionship()} isRegular={isRegular}>
                <span style={this.spanPrevStyle(this.state.refLiFirst)} className="arrow orange prev icon" onClick={e => this.scroll_button('ref', 'prev', e)} onKeyPress={e => this.scroll_button('prev', e)}>&#xf123;</span>
                <ul className="scroll-ul" ref={el => this.ref = el} onScroll={() => this.handleScroll('ref')} style={{ marginBottom: 0 }}>
                  {tabs.map(index => (
                    <TabPanel
                      label={this.phaseLabel(index)}
                      isSelected={currentPhase}
                      key={index + 1}
                      index={index}
                      setActiveTab={this.setActiveTab}
                      isCup={isCup}
                      isSpecialChampionship={this.isSpecialChampionship()}
                    />
                  ))
                  }
                </ul>
                <span style={this.spanNextStyle(this.state.refLiLast)} className="arrow orange next icon" onClick={e => this.scroll_button('ref', 'next', e)} onKeyPress={e => this.scroll_button('next', e)}>&#xf124;</span>
              </PhasesWrapper>
            }
          </React.Fragment>

        }
        {subTabs && isInnerMenu && subTabs.length > 0 &&
          <SubPhasesWrapper>
            <span style={this.spanPrevStyle(this.state.subRefLiFirst)} className="arrow orange prev icon" onClick={e => this.scroll_button('subRef', 'prev', e)} onKeyPress={e => this.scroll_button('prev', e)}>&#xf123;</span>
            {currentPhase === 'groups' && !isBasketCup(window.matchcenterPage.competitionId) &&
              <Label
                label={this.subPhaseLabel()}
                isTitleNarrowMedium={!isMobile}
                margin="0px 5px 10px 5px"
                alignText="left"
                block
              />
            }
            <ul className="scroll-ul" ref={el => this.subRef = el} onScroll={() => this.handleScroll('subRef')} style={{ marginBottom: 0 }}>
              {subTabs && subTabs.map(index => (
                <TabPanel
                  label={this.subTabsLabel(index, isUefaCompetition)}
                  isSelected={currentSubPhase}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setActiveSubTab}
                  size={(Number(window.matchcenterPage.competitionId) === 335 && isMobile) ? '18px' : '16px'}
                  isCup={isCup}
                  isShort={subTabs.length < 6}
                />
              ))
              }
            </ul>
            <span style={this.spanNextStyle(this.state.subRefLiLast)} className="arrow orange next icon" onClick={e => this.scroll_button('subRef', 'next', e)} onKeyPress={e => this.scroll_button('next', e)}>&#xf124;</span>
          </SubPhasesWrapper>
        }
        {this.isSpecialChampionship() && isInnerMenu && this.renderNestTitle()}
      </CupTabbarWrapper>
    );
  }
}

CupCalendarTabbar.propTypes = {
  currentPhase: PropTypes.any,
  currentSubPhase: PropTypes.any,
  phases: PropTypes.any,
  dictionary: PropTypes.any,
  // actions: PropTypes.any,
  isCup: PropTypes.bool,
  isMobile: PropTypes.bool,
  isSpecial: PropTypes.bool,
  isVolleyChampionship: PropTypes.bool,
  isInnerMenu: PropTypes.bool,
  isRugby: PropTypes.bool,
  isBasketSerieA: PropTypes.bool,
  isFootballSerieB: PropTypes.bool,
  isUefaCompetition: PropTypes.bool,
};

export default CupCalendarTabbar;



// WEBPACK FOOTER //
// ./src/components/CupCalendarTabbar/index.js